import { FormEvent } from "react";
import { FieldValues, FormProvider } from "react-hook-form";
import { Flex } from "../flex/Flex.Parts";
import { Props } from "./Form.Parts";

export const Form = <T extends FieldValues>({
  onSubmit,
  formMethods,
  children,
  validate = true,
  ...rest
}: Props<T>) => {
  const handleSubmit = validate
    ? formMethods.handleSubmit(onSubmit)
    : (e: FormEvent) => {
        e.preventDefault();
        onSubmit(formMethods.getValues(), e);
      };

  return (
    <FormProvider {...formMethods}>
      <Flex as="form" $flow="column" onSubmit={handleSubmit} {...rest}>
        {children}
      </Flex>
    </FormProvider>
  );
};
